import {
  IExposedForBizBrowser,
  alertMessage,
  receiveScannedResults,
  toastMessage,
  sendStateToBizBrowser,
  updateRfidConnectionStatus,
  updateRfidPowerLevel,
} from './exposedForBizBrowser'

declare global {
  interface Window {
    bizsd?: {
      postMessage: (message: string) => void
    }
    isConnectedWithBizBrowser?: boolean
    exposedForBizBrowser: IExposedForBizBrowser
  }
}

// Expose functions to global scope for BizBrowser to invoke
if (typeof window !== 'undefined') {
  window.exposedForBizBrowser = {
    alertMessage,
    toastMessage,
    sendStateToBizBrowser,
    receiveScannedResults,
    updateRfidConnectionStatus,
    updateRfidPowerLevel,
  }
}
